import sendToServer from './send-to-server';
import anchorme from "anchorme";

const Journal = {
  init() {
    if (!($('.journal.edit').length > 0)) return;
    $('.adder').click(this.handleAdderClick.bind(this));
    $('.canceller').click(this.handleCancellerClick.bind(this));
    $('.submitter').click(this.handleSubmitterClick.bind(this));
    $('.updater').click(this.handleUpdaterClick.bind(this));
    $('.note-editor').click(this.handleNoteContentClick.bind(this));
    $('.notes-updater').click(this.handleNotesUpdateClick.bind(this));

    this.populateContent();
  },

  handleAdderClick(event) {
    const adderButton = $(event.target).closest('.adder');
    adderButton.hide();
    const adderForm = $('.' + adderButton.data('form'));
    adderForm.show();
  },

  handleCancellerClick(event) {
    const cancellerButton = $(event.target).closest('.canceller');
    const form = cancellerButton.closest('.form')

    form.hide();
    form.find("input").each((_, element) => {
      $(element).val('');
    });

    $('.note-content-holder').show();

    cancellerButton.closest('.section').find('.adder').show();
  },

  handleSubmitterClick(event) {
    const submitterButton = $(event.target).closest('.submitter');
    const form = submitterButton.closest('.add-form');
    const fields = {}
    form.find("input, select").each((_, element) => {
      const $elem = $(element);
      fields[$elem.data('attribute')] = $elem.val();
      $elem.val('');
    });

    const section = submitterButton.closest('.section').data('section-name');
    const existingData = $('#prop-holder').data('props')[section];
    const data = existingData.map(a => ({...a}));
    data.push(fields);

    form.hide();

    $('#prop-holder').data('props')[section] = data;

    sendToServer('/api/v2/journal',
                 { [section]: data },
                 this.handleUpdateResponse.bind(this),
                 'PATCH');
    submitterButton.closest('.section').find('.adder').show();
  },

  handleUpdaterClick(event) {
    const updaterButton = $(event.target).closest('.updater');
    const form = updaterButton.closest('.edit-form');
    const index = form.find('.edit-index').val();
    const fields = {}
    form.find("input, select").each((_, element) => {
      const $elem = $(element);
      if ($elem.data('attribute')) fields[$elem.data('attribute')] = $elem.val();
      $elem.val('');
    });

    const section = updaterButton.closest('.section').data('section-name');
    const existingData = $('#prop-holder').data('props')[section];
    const data = existingData.map(a => ({...a}));
    data[index] = fields;

    form.hide();

    $('#prop-holder').data('props')[section] = data;

    sendToServer('/api/v2/journal',
                 { [section]: data },
                 this.handleUpdateResponse.bind(this),
                 'PATCH');

    updaterButton.closest('.section').find('.adder').show();
  },

  handleDeleterClick(event, deleter) {
    const deleterButton = deleter || $(event.target).closest('.deleter');
    const section = deleterButton.closest('.section').data('section-name');

    const existingData = $('#prop-holder').data('props')[section];
    const data = existingData.map(a => ({...a}));
    data.splice(deleterButton.data('index'), 1);

    $('#prop-holder').data('props')[section] = data;

    sendToServer('/api/v2/journal',
                 { [section]: data },
                 this.handleUpdateResponse.bind(this),
                 'PATCH');
  },

  handleEditorClick(event) {
    const editorButton = $(event.target).closest('.editor');
    if (editorButton.prop('href').length > 0) return;

    const sectionElement = editorButton.closest('.section')
    const section = sectionElement.data('section-name');

    const existingData = $('#prop-holder').data('props')[section];
    const existingEntity = existingData[editorButton.data('index')];
    const form = sectionElement.find('.edit-form');
    form.find("input, select").each((_, element) => {
      const $elem = $(element);
      if ($($elem).data('attribute')) {
        $elem.val(existingEntity[$($elem).data('attribute')])
      }
    });
    form.find('.edit-index').val(editorButton.data('index'));
    form.show();
    editorButton.closest('.section').find('.adder').hide();
  },

  handleApplierClick(event) {
    const applierButton = $(event.target).closest('.applier');
    const existingData = $('#prop-holder').data('props')['vacancies'];
    const existingEntity = existingData[applierButton.data('index')];

    // Create a new application
    existingEntity.tasks = [];
    existingEntity.id = this.guid();
    existingEntity.status = 'preparing_application';
    const existingApplications = $('#prop-holder').data('props')['applications'];
    const data = existingApplications.map(a => ({...a}));
    data.push(existingEntity);

    sendToServer('/api/v2/journal',
                 { 'applications': data },
                 () => { this.handleDeleterClick(event, $(event.target).closest('.section').find('.deleter')); },
                 'PATCH');
  },

  handleUpdateResponse(response) {
    const newData = response.responseJSON;
    $('#prop-holder').data('props', newData);
    this.populateContent();
  },

  populateContent() {
    const data = $('#prop-holder').data('props');
    this.populateCompanies(data);
    this.populateVacancies(data);
    this.populateNotes(data);
    this.populateApplications(data);
    this.setEventHandlers();
  },

  populateCompanies(data) {
    $('.company-content').html('');
    $('.company-content').closest('.section').find('.prompt').show();

    $(data.companies).each((index, company) => {
      $('.company-content').closest('.section').find('.prompt').hide();

      const companyElement = $('<div>', { class: 'company' });
      let url = company.url.trim();
      if (url.length > 0) {
        if (url.indexOf('http') !== 0) {
          url = 'http://' + url;
        }
        const link = $('<a>', { class: 'company-name', href: url, text: company.name, target: '_blank' });
        companyElement.append(link);
      } else {
        const name = $('<div>', { class: 'company-name', text: company.name });
        companyElement.append(name);
      }

      companyElement.append($('<a>', { class: 'glyphicon glyphicon-pencil editor', 'data-index': index }));
      companyElement.append($('<a>', { class: 'glyphicon glyphicon-remove deleter', 'data-index': index }));

      $('.company-content').append(companyElement);

    });
  },

  populateVacancies(data) {
    $('.vacancy-content').html('');
    $('.vacancy-content').closest('.section').find('.prompt').show();

    $(data.vacancies).each((index, vacancy) => {
      $('.vacancy-content').closest('.section').find('.prompt').hide();

      const vacancyElement = $('<div>', { class: 'vacancy' });
      let url = vacancy.url.trim();
      var topRow = vacancy.title;
      const careerName = $('#prop-holder').data('careers')[vacancy.career_id];
      if (careerName) {
        topRow += ' (' + careerName + ')';
      }
      if (url.length > 0) {
        if (url.indexOf('http') !== 0) {
          url = 'http://' + url;
        }
        const link = $('<a>', { class: 'vacancy-title', href: url, text: topRow, target: '_blank' });
        vacancyElement.append(link);
      } else {
        const name = $('<div>', { class: 'vacancy-title', text: topRow });
        vacancyElement.append(name);
      }


      if (vacancy.company && vacancy.company.length > 0) {
        vacancyElement.append($('<div>', { class: 'vacancy-company', text: '@ ' + vacancy.company }));
      }

      vacancyElement.append($('<a>', { class: 'glyphicon glyphicon-pencil editor', 'data-index': index }));
      vacancyElement.append($('<a>', { class: 'glyphicon glyphicon-remove deleter', 'data-index': index }));
      vacancyElement.append($('<a>', { class: 'applier', 'data-index': index, text: $('#prop-holder').data('apply-text') }));

      $('.vacancy-content').append(vacancyElement);

    });
  },

  populateNotes(data) {
    $('.note-content').html('');

    if (data.notes.length > 0) {
      $('.note-content').closest('.section').find('.prompt').hide();
    } else {
      $('.note-content').closest('.section').find('.prompt').show();
    }
    const safed = $('<div/>').text(data.notes).html();
    const lineBroken = (safed + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br> $2');
    const anchored = anchorme(lineBroken, { attributes: [{ name: 'target', value: '_blank'}]});
    $('.note-content').html(anchored);
  },

  populateApplications(data) {
    $('.application-content').html('');
    $('.application-content').closest('.section').find('.prompt').show();

    $(data.applications).each((index, application) => {
      $('.application-content').closest('.section').find('.prompt').hide();

      const applicationElement = $('<div>', { class: 'application' });

      const topRow = $('<div>', { class: 'application-top-row' });

      let url = application.url.trim();
      var topRowText = application.title;
      const careerName = $('#prop-holder').data('careers')[application.career_id];
      if (careerName) {
        topRowText += ' (' + careerName + ')';
      }

      if (url.length > 0) {
        if (url.indexOf('http') !== 0) {
          url = 'http://' + url;
        }
        const link = $('<a>', { class: 'application-title', href: url, text: topRowText, target: '_blank' });
        topRow.append(link);
      } else {
        const name = $('<div>', { class: 'application-title', text: topRowText });
        topRow.append(name);
      }

      const statuses = $('#prop-holder').data('statuses');
      topRow.append($('<div>', { class: 'application-status', text: statuses[application.status] }));

      applicationElement.append(topRow);

      if (application.company && application.company.length > 0) {
        applicationElement.append($('<div>', { class: 'application-company', text: '@ ' + application.company }));
      }

      const path = '/app/journal/applications/' + application.id;

      applicationElement.append($('<a>', { class: 'glyphicon glyphicon-pencil editor', href: path + '/edit' }));
      applicationElement.append($('<a>', { class: 'glyphicon glyphicon-remove deleter', 'data-index': index }));

      $('.application-content').append(applicationElement);

    });
  },

  handleNoteContentClick() {
    $('.note-content-holder').hide()
    const notes = $('#prop-holder').data('props').notes;
    $('.note-edit-form textarea').val(notes);
    $('.note-edit-form').show();
  },

  handleNotesUpdateClick() {
    const notes = $('.note-edit-form textarea').val().trim();
    sendToServer('/api/v2/journal',
                 { notes: notes },
                 this.handleUpdateResponse.bind(this),
                 'PATCH');
   $('.note-edit-form').hide();
   $('.note-content-holder').show();
  },

  setEventHandlers() {
    $('.deleter').click(this.handleDeleterClick.bind(this));
    $('.editor').click(this.handleEditorClick.bind(this));
    $('.applier').click(this.handleApplierClick.bind(this));
  },

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }
};

$(document).ready(()=> {
  Journal.init();
});
